<template>
  <v-card
    :class="['card-shell', { 'card-shell--flat': elevation === 0, 'card-shell--inactive': inactive, 'card-shell--click-disabled': !clickable, 'card-shell--dimming': dimming }]"
    :border="flat ? false : elevation === 0"
    :elevation="elevation"
    @click="clickable && $emit('click', $event)"
  >
    <v-card-text class="position-relative">
      <div v-if="$slots.title" class="text-body-2 font-weight-medium mb-1">
        <slot name="title" />
      </div>
      <div v-if="$slots.subtitle" class="text-body-2 text-medium-emphasis mb-1">
        <slot name="subtitle" />
      </div>
      <div v-if="$slots.actions" class="card-shell__actions">
        <slot name="actions" />
      </div>
      <slot />
      <div v-if="$slots.footer" class="card-shell__footer">
        <slot name="footer" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CardShell",
  data() {
    return {
      dimming: false
    };
  },
  watch: {
    inactive(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.dimming = true;
      } else if (!newVal && oldVal) {
        this.dimming = false;
      }
    }
  },
  props: {
    elevation: {
      type: Number,
      default: 2
    },
    clickable: {
      type: Boolean,
      default: true
    },
    inactive: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"]
};
</script>

<style scoped>
.card-shell--inactive {
  opacity: 0.5;
}
.card-shell--dimming {
  animation: dim 20s ease forwards;
}
@keyframes dim {
  from { opacity: 1; }
  to { opacity: 0.5; }
}
.card-shell--flat {
  --v-border-opacity: 0.25;
}
.card-shell--click-disabled {
  pointer-events: none;
}
.card-shell__actions {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
}
.card-shell__footer {
  margin-top: 8px;
}
.card-shell :deep(.v-card-text) {
  color: rgb(var(--v-theme-on-surface));
}
</style>